const pivotTableSpec = {
  version: 1,
  filters: [],
  aggregation: 'count',
  valueColumn: null,
  categoryColumn: null,
  categoryTitle: null,
  rowColumn: null,
  rowTitle: null,
  decimalPlaces: 3,
  valueDisplay: 'default',
  hideRowTotals: false,
  hideColumnTotals: false,
};

export default pivotTableSpec;



// WEBPACK FOOTER //
// ./src/constants/Visualisation/pivotTableSpecTemplate.js